import React, { useState } from 'react';
import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiSend,
  FiClock,
  FiZap,
} from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import Reveal from '../common/Reveal';
import contactHeroImg from '../assest/contact us .jpg.png';

const PHONE_1 = '+91 9958260035';
const PHONE_1_DISPLAY = '+91 9958260035';
const PHONE_2 = '+91 9958260035';
const PHONE_2_DISPLAY = '+91 9958260035';
const EMAIL = 'info@prithvirajlimited.com';
const WHATSAPP_LINK = `https://wa.me/${PHONE_1.replace('+', '')}`;

const offices = [
  {
    title: 'Registered Office',
    address:
      'Unit No 930B, 9th floor, Tower B, Spaze I Tech Park, Sector-49, Sohna Road, Gurugram (HR) - 122018',
    phone: PHONE_2_DISPLAY,
    phoneHref: PHONE_2,
  },
  {
    title: 'Manufacturing Office',
    address: 'C/O Prince Kumar, At P.O. Keshawe, P.S. - Barauni, Begusarai, Bihar, India - 851134',
    phone: PHONE_1_DISPLAY,
    phoneHref: PHONE_1,
  },
];

const countries = ['India', 'United Arab Emirates', 'Nepal', 'Bangladesh', 'Other'];

const supportCards = [
  {
    icon: FiPhone,
    title: 'Call Support',
    value: PHONE_1_DISPLAY,
    sub: 'Mon–Sat, 9:30 AM–6:30 PM',
    href: `tel:${PHONE_1}`,
  },
  {
    icon: FiMail,
    title: 'Email Support',
    value: EMAIL,
    sub: 'We reply within one business day',
    href: `mailto:${EMAIL}`,
  },
  {
    icon: FaWhatsapp,
    title: 'WhatsApp Chat',
    value: PHONE_1_DISPLAY,
    sub: 'Fastest way to reach us',
    href: WHATSAPP_LINK,
  },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', country: 'India', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Website Enquiry from ${form.name || 'Website Visitor'}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nContact Number: ${form.phone}\nCountry: ${form.country}\n\nMessage:\n${form.message}`
    );
    window.location.href = `mailto:${EMAIL}?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <div className="overflow-x-hidden bg-white">
      {/* local keyframes for the connecting-current / signal-pulse motifs used below */}
      <style>{`
        @media (prefers-reduced-motion: no-preference) {
          @keyframes pcl-flow {
            from { background-position-x: 0; }
            to   { background-position-x: -32px; }
          }
          @keyframes pcl-pulse {
            0%, 100% { box-shadow: 0 0 0 0 rgba(249,115,22,0.45); }
            50%      { box-shadow: 0 0 0 7px rgba(249,115,22,0); }
          }
          @keyframes pcl-drift {
            0%, 100% { transform: translateY(0); }
            50%      { transform: translateY(-6px); }
          }
          .pcl-current-line { animation: pcl-flow 1.1s linear infinite; }
          .pcl-led { animation: pcl-pulse 2.2s ease-in-out infinite; }
          .pcl-drift { animation: pcl-drift 5s ease-in-out infinite; }
        }
      `}</style>

      {/* ---------------- HERO BANNER ---------------- */}
      <section className="relative w-full overflow-hidden">
        {/* <img
          src={contactHeroImg}
          alt="Prithviraj Corporation Limited"
          className="h-[280px] w-full object-cover sm:h-[380px] lg:h-[420px]"
        /> */}
        <img
  src={contactHeroImg}
  alt="Prithviraj Corporation Limited"
  className="h-[220px] w-full object-cover object-center sm:h-[380px] lg:h-[420px]"
/>
      </section>

      {/* ---------------- OFFICES + CONTACT FORM ---------------- */}
      <section className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        {/* faint industrial dot-grid texture, contained to this section only */}
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.35]"
          style={{
            backgroundImage: 'radial-gradient(circle, rgba(15,23,60,0.10) 1px, transparent 1px)',
            backgroundSize: '22px 22px',
            maskImage: 'radial-gradient(ellipse 60% 50% at 15% 20%, black, transparent)',
          }}
        />

        <div className="relative grid gap-10 lg:grid-cols-2">
          {/* ---------------- LEFT: OFFICE ADDRESSES ---------------- */}
          <div className="relative">
            {/* connecting signal rail between the two offices */}
            <span className="pointer-events-none absolute left-[17px] top-11 bottom-[168px] hidden w-px bg-gradient-to-b from-brand-orange/50 via-brand-orange/15 to-transparent sm:block" />

            <div className="space-y-8">
              {offices.map((office, i) => (
                <Reveal key={office.title} delay={i * 100}>
                  <div className="group relative rounded-2xl border border-slate-100 bg-white p-5 transition duration-300 hover:-translate-y-0.5 hover:border-brand-orange/30 hover:shadow-lg hover:shadow-navy/5">
                    <div className="flex items-center gap-3">
                      <span className="pcl-led relative flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-navy text-brand-orange">
                        <FiMapPin size={17} />
                      </span>
                      <h3 className="text-lg font-extrabold text-navy">{office.title}</h3>
                    </div>
                    <span className="mb-4 mt-3 block h-[2px] w-16 rounded-full bg-brand-orange transition-all duration-300 group-hover:w-24" />
                    <p className="flex items-start gap-2.5 text-sm leading-relaxed text-slate-600">
                      <FiMapPin className="mt-0.5 shrink-0 text-brand-orange" size={15} />
                      {office.address}
                    </p>
                    <a
                      href={`tel:${office.phoneHref}`}
                      className="mt-2.5 flex items-center gap-2.5 text-sm font-medium text-slate-600 transition hover:text-brand-orange"
                    >
                      <FiPhone className="shrink-0 text-brand-orange" size={15} />
                      {office.phone}
                    </a>
                    <a
                      href={`mailto:${EMAIL}`}
                      className="mt-2.5 flex items-center gap-2.5 text-sm font-medium text-slate-600 transition hover:text-brand-orange"
                    >
                      <FiMail className="shrink-0 text-brand-orange" size={15} />
                      {EMAIL}
                    </a>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={200} className="mt-8 flex items-start gap-3 rounded-2xl border-l-4 border-brand-orange bg-slate-50 p-5">
              <FiClock className="mt-0.5 shrink-0 text-brand-orange" size={18} />
              <p className="text-sm leading-relaxed text-slate-600">
                <span className="font-bold text-navy">Working Hours:</span> Mon &ndash; Sat, 9:30 AM &ndash; 6:30 PM IST
              </p>
            </Reveal>
          </div>

          {/* ---------------- RIGHT: CONTACT FORM ---------------- */}
          <Reveal delay={100}>
            <div className="relative overflow-hidden rounded-3xl p-[1.5px]">
              {/* rotating glow border */}
              <div className="pointer-events-none absolute left-1/2 top-1/2 z-0 h-[200%] w-[200%] -translate-x-1/2 -translate-y-1/2 animate-borderSpin bg-[conic-gradient(from_0deg,transparent_0%,theme(colors.brand.orange)_15%,transparent_35%)]" />

              {/* actual card */}
              <div className="relative z-10 overflow-hidden rounded-3xl bg-navy p-6 sm:p-8">
                {/* subtle circuit dot-grid texture, contained and faded toward the corner */}
                <div
                  className="pointer-events-none absolute inset-0 opacity-[0.06]"
                  style={{
                    backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
                    backgroundSize: '18px 18px',
                    maskImage: 'radial-gradient(ellipse 70% 60% at 85% 10%, black, transparent)',
                  }}
                />
                {/* soft orange glow anchored bottom-left */}
                <div className="pointer-events-none absolute -bottom-16 -left-16 h-56 w-56 rounded-full bg-brand-orange/20 blur-3xl" />

                <div className="relative">
                  <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-brand-orange">
                    <FiZap size={11} /> Send A Message
                  </span>
                  <h3 className="mt-3 text-2xl font-extrabold text-white sm:text-[26px]">
                    Let&rsquo;s Get In Touch
                  </h3>
                  <p className="mt-1.5 text-sm text-white/50">
                    Fill in your details and our team will get back to you shortly.
                  </p>

                  <form onSubmit={handleSubmit} className="mt-7 space-y-4">
                    <div className="grid gap-4 sm:grid-cols-2">
                      <input
                        type="text"
                        name="name"
                        required
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Full name"
                        className="w-full rounded-xl border border-white/10 bg-white/[0.06] px-4 py-3.5 text-sm text-white placeholder:text-white/35 transition focus:border-brand-orange focus:bg-white/[0.09] focus:outline-none focus:ring-1 focus:ring-brand-orange"
                      />
                      <input
                        type="email"
                        name="email"
                        required
                        value={form.email}
                        onChange={handleChange}
                        placeholder="Email address"
                        className="w-full rounded-xl border border-white/10 bg-white/[0.06] px-4 py-3.5 text-sm text-white placeholder:text-white/35 transition focus:border-brand-orange focus:bg-white/[0.09] focus:outline-none focus:ring-1 focus:ring-brand-orange"
                      />
                    </div>

                    <div className="grid gap-4 sm:grid-cols-2">
                      <div className="flex overflow-hidden rounded-xl border border-white/10 bg-white/[0.06] transition focus-within:border-brand-orange focus-within:bg-white/[0.09] focus-within:ring-1 focus-within:ring-brand-orange">
                        <span className="flex items-center border-r border-white/10 px-3 text-sm font-semibold text-white/45">
                          +91
                        </span>
                        <input
                          type="tel"
                          name="phone"
                          required
                          value={form.phone}
                          onChange={handleChange}
                          placeholder="Contact number"
                          className="w-full bg-transparent px-3 py-3.5 text-sm text-white placeholder:text-white/35 focus:outline-none"
                        />
                      </div>
                      <select
                        name="country"
                        value={form.country}
                        onChange={handleChange}
                        className="w-full rounded-xl border border-white/10 bg-white/[0.06] px-4 py-3.5 text-sm text-white transition focus:border-brand-orange focus:bg-white/[0.09] focus:outline-none focus:ring-1 focus:ring-brand-orange [&>option]:text-black"
                      >
                        {countries.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </select>
                    </div>

                    <textarea
                      name="message"
                      required
                      rows={5}
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Tell us what you need..."
                      className="w-full resize-none rounded-xl border border-white/10 bg-white/[0.06] px-4 py-3.5 text-sm text-white placeholder:text-white/35 transition focus:border-brand-orange focus:bg-white/[0.09] focus:outline-none focus:ring-1 focus:ring-brand-orange"
                    />

                    <button
                      type="submit"
                      className="group flex w-full items-center justify-center gap-2 rounded-full bg-brand-orange px-6 py-3.5 text-sm font-bold uppercase tracking-wide text-white shadow-lg shadow-brand-orange/25 transition duration-300 hover:-translate-y-0.5 hover:bg-brand-orangedark hover:shadow-xl hover:shadow-brand-orange/30"
                    >
                      Submit
                      <FiSend className="transition group-hover:translate-x-1" size={15} />
                    </button>

                    {sent && (
                      <p className="text-center text-xs font-semibold text-emerald-400">
                        Thanks! Your email app should now open with your message ready to send.
                      </p>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ---------------- CUSTOMER SUPPORT ---------------- */}
      <section className="relative overflow-hidden bg-navy py-16 sm:py-20">
        {/* faint drifting glow orbs for ambience, matching the industrial/electric brand */}
        <div className="pcl-drift pointer-events-none absolute -left-16 top-10 h-56 w-56 rounded-full bg-brand-orange/10 blur-3xl" />
        <div className="pcl-drift pointer-events-none absolute -right-10 bottom-0 h-64 w-64 rounded-full bg-brand-orange/10 blur-3xl" style={{ animationDelay: '1.4s' }} />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3.5 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-brand-orange">
              <FiZap size={12} /> Talk To Us
            </span>
            <h2 className="mt-4 text-2xl font-extrabold text-white sm:text-3xl">Customer Support</h2>
            <p className="mt-2 text-sm text-white/60 sm:text-base">
              Reach us through any of the following channels
            </p>
          </Reveal>

          <div className="relative mt-14">
            {/* animated current line connecting the three channels — desktop only */}
            <div className="pointer-events-none absolute left-[16.6%] right-[16.6%] top-7 hidden h-[2px] overflow-hidden md:block">
              <div
                className="pcl-current-line h-full w-full"
                style={{
                  backgroundImage:
                    'repeating-linear-gradient(90deg, transparent 0 6px, rgba(249,115,22,0.9) 6px 10px, transparent 10px 16px)',
                  backgroundSize: '32px 2px',
                }}
              />
            </div>

            <div className="grid gap-6 sm:grid-cols-3">
              {supportCards.map((card, i) => {
                const Icon = card.icon;
                const isWhatsapp = card.icon === FaWhatsapp;
                return (
                  <Reveal key={card.title} delay={i * 120}>
                    <a
                      href={card.href}
                      target={isWhatsapp ? '_blank' : undefined}
                      rel={isWhatsapp ? 'noreferrer' : undefined}
                      className="group relative flex h-full flex-col items-center overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04] p-8 text-center backdrop-blur-sm transition duration-300 hover:-translate-y-1.5 hover:border-brand-orange/40 hover:bg-white/[0.07] hover:shadow-xl hover:shadow-brand-orange/10"
                    >
                      <span
                        className="relative z-10 flex h-14 w-14 items-center justify-center bg-gradient-to-br from-brand-orange to-brand-orangedark text-white transition duration-300 group-hover:scale-110"
                        style={{ clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
                      >
                        <Icon size={22} />
                      </span>
                      <p className="relative z-10 mt-5 text-base font-bold text-white">{card.title}</p>
                      <p className="relative z-10 mt-1 text-sm text-white/70">{card.value}</p>
                      <p className="relative z-10 mt-1 text-xs text-white/40">{card.sub}</p>
                      <span className="relative z-10 mt-4 block h-[2px] w-8 rounded-full bg-brand-orange/50 transition-all duration-300 group-hover:w-16 group-hover:bg-brand-orange" />
                    </a>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}